(() => {
  window.addEventListener('DOMContentLoaded', () => {
    const wrappers = document.querySelectorAll('[data-readmore-wrapper]');

    wrappers.forEach(wrapper => {
      const text = wrapper.querySelector('[data-readmore-text]');
      const btnMore = wrapper.querySelector('[data-readmore-more]');
      const btnLess = wrapper.querySelector('[data-readmore-less]');
      const isRichText = wrapper.querySelector('[data-rich-text]');

      if (!text || !btnMore || !btnLess) return;

      const isClamped = el => el.scrollHeight > el.clientHeight + 1;

      const checkClamp = () => {
        if (text.classList.contains('expanded')) return;
        if (isClamped(text)) {
          btnMore.style.display = isRichText ? 'block' : 'inline';
          btnLess.style.display = 'none';
        } else {
          btnMore.style.display = 'none';
          btnLess.style.display = 'none';
        }
      };

      checkClamp();

      btnMore.addEventListener('click', () => {
        text.classList.add('expanded');
        btnMore.style.display = 'none';
        btnLess.style.display = isRichText ? 'block' : 'inline';
      });

      btnLess.addEventListener('click', () => {
        text.classList.remove('expanded');
        btnMore.style.display = isRichText ? 'block' : 'inline';
        btnLess.style.display = 'none';
      });

      window.addEventListener('resize', checkClamp);
    });
  });
})();